import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaCubes, FaHome } from 'react-icons/fa';
import ModulosCatalog from './ModulosCatalog';
import { useNavigate } from 'react-router-dom';

export default function ModulosPage() {
    const isSmall = isMobile || isTablet;
    const navigate = useNavigate();

    return (
        <div className="panel-sigma-layout">
            <aside className={`panel-sigma-sidebar ${isSmall ? 'panel-sigma-sidebar-responsive' : ''}`}>
                {!isSmall && (
                    <div className="panel-sigma-avatar">
                        <FaCubes size={48} />
                    </div>
                )}
                <nav className="panel-sigma-nav">
                    {/* Botón para volver al menú de seguridad */}
                    <button title="Inicio" onClick={() => navigate('/menu/roles')}>
                        <FaHome />
                    </button>
                </nav>
            </aside>

            <ModulosCatalog />
        </div>
    );
}
